import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { AppService } from 'app/app.service';
import { lastValueFrom, Subject } from 'rxjs';
import { defaultIfEmpty, takeUntil } from 'rxjs/operators';
import { DialogRassegnaStampaComponent } from '../../../main/pages/dialog-rassegna-stampa/dialog-rassegna-stampa.component';
import { NotificaService } from 'app/main/utils/service/notifica.service';
import { CostantiStorage, Piattaforma } from 'app/main/utils/costanti';
import { Utils } from 'app/main/utils/utils';
import { environment } from 'environments/environment';
import { UtentiService } from 'app/main/utils/service/utente.service';
import { DataFormattedPipe } from 'app/main/utils/pipes/dataFormatted.pipe';

@Component({
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, DataFormattedPipe],
  selector: 'quick-panel',
  templateUrl: './quick-panel.component.html',
  styleUrls: ['./quick-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuickPanelComponent implements OnInit, OnDestroy {
  date: Date;
  events: any[];
  notes: any[];
  settings: any;
  notifications = [];
  notificationsRead = [];
  notificationsNew = [];
  notificationState: 'idle' | 'loading' | 'loaded' | 'error' = 'idle';

  private _unsubscribeAll: Subject<any>;
  private _destroyed = false;

  constructor(
    private _httpClient: HttpClient,
    private dialog: MatDialog,
    private _fuseSidebarService: FuseSidebarService,
    private notificaService: NotificaService,
    private router: Router,
    private appService: AppService,
    private utenteService: UtentiService,
    private cd: ChangeDetectorRef
  ) {
    // Set the defaults
    this.date = new Date();
    this.settings = {
      notify: true,
      cloud: false,
      retro: true
    };

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.appService.onReloadNotification.pipe(takeUntil(this._unsubscribeAll)).subscribe(state => {
      if (state && this._fuseSidebarService.getSidebar('quickPanel').opened) {
        this.getListaNotifiche();
      }
    });

    //     this._httpClient
    //       .get('api/quick-panel-events')
    //       .pipe(takeUntil(this._unsubscribeAll))
    //       .subscribe((response: any) => {
    //         this.events = response;
    //       });
    //
    //     this._httpClient
    //       .get('api/quick-panel-notes')
    //       .pipe(takeUntil(this._unsubscribeAll))
    //       .subscribe((response: any) => {
    //         this.notes = response;
    //       });
  }

  async getListaNotifiche() {
    if (localStorage.getItem(CostantiStorage.TOKEN)) {
      this.notificationState = 'loading';
      this.cd.detectChanges();
      try {
        const data = await lastValueFrom(
          this.notificaService.listaUltimeNotifiche().pipe(takeUntil(this._unsubscribeAll), defaultIfEmpty(null))
        );
        if (this._destroyed) {
          return;
        }

        if (data && !data['error'] && Array.isArray(data['notifiche'])) {
          this.notifications = data['notifiche'];
          this.notificationState = 'loaded';
          this.cd.detectChanges();
          this.splitNotifiche();
        } else {
          this.notificationState = 'error';
          this.cd.detectChanges();
        }
      } catch {
        if (this._destroyed) {
          return;
        }
        this.notificationState = 'error';
        this.cd.detectChanges();
      }
    }
  }
  setNotificaLetta(item, followUrl = true) {
    item.is_letta = 1;
    this.notificaService
      .updateLettaNotifica(item.id_notifica)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(data => {
        this.cd.detectChanges();
        if (!data['error']) {
          this.notificaService.checkNotifiche.next(true);
          this.splitNotifiche();
        }
      });
    if (followUrl && item.url_destinazione) {
      if (item.id_piattaforma !== Piattaforma.Servizi) {
        this.utenteService
          .switchPreLogin()
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe(data => {
            if (!data['error']) {
              const urlAppend = `/${data['response']}?notification=${encodeURIComponent(btoa(item.url_destinazione))}`;
              let url: string;
              switch (item.id_piattaforma) {
                case Piattaforma.Anagrafica:
                  url = environment.urlPreLoginAnagrafica;
                  break;
                case Piattaforma.Social:
                  url = environment.urlPreLoginSocial;
              }
              window.location.href = url + urlAppend;
            } else {
              console.error('1');
            }
          });
      } else {
        this.router.navigateByUrl(item.url_destinazione);
      }
    }
    if (followUrl && this._fuseSidebarService.getSidebar('quickPanel')) {
      this._fuseSidebarService.getSidebar('quickPanel').close();
    }
  }
  visualizzaTutteNotifiche() {
    this.utenteService
      .switchPreLogin()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(data => {
        if (!data['error']) {
          const urlAppend = `/${data['response']}?notification=${encodeURIComponent(btoa('/notifiche'))}`;
          window.location.href = environment.urlPreLoginSocial + urlAppend;
        } else {
          console.error('1');
        }
      });
  }
  isNotificaNonLetta() {
    return this.notifications.some(item => item.is_letta === 0);
  }
  splitNotifiche() {
    const [readNotif, newNotif] = Utils.partition(this.notifications, x => x.is_letta);
    this.notificationsRead = readNotif;
    this.notificationsNew = newNotif;
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this._destroyed = true;
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }

  toggleSidebarOpen(key): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  openRassegna() {
    this.dialog.open(DialogRassegnaStampaComponent, {
      height: '70vh',
      maxHeight: '600px'
    });
  }
}
